import React from "react";
import admin from "../../Image/team-1.jpg";
import {
  FaColumns,
  FaServicestack,
  FaSlidersH,
  FaRegAddressCard,
  FaEnvelope,
  FaSearch,
  FaPowerOff,
  FaCog,
  FaBell,
  FaCalendarAlt,
  FaExchangeAlt,
  FaHome,
  FaUsers,
} from "react-icons/fa";
import { NavLink, Outlet } from "react-router-dom";
import "../Styling-css/AdminLayout.css";

const AdminLayout = () => {
  return (
    <div className="admin-container">
      {/* Navbar */}
      <nav className="admin-nav">
        <div className="admin-nav-left">
          <div className="admin-logo">KirayaWala</div>
          <FaExchangeAlt className="admin-icon" />
        </div>

        <div className="admin-nav-center">
          <FaCalendarAlt className="admin-icon" />
          <FaEnvelope className="admin-icon" />
          <FaUsers className="admin-icon" />
          <div className="admin-notification">
            <FaBell className="admin-icon" />
            <span className="admin-dot"></span>
          </div>
          <div className="admin-search-box">
            <input type="text" placeholder="Search..." />
            <FaSearch className="admin-search-icon" />
          </div>
        </div>

        <div className="admin-nav-right">
          <FaPowerOff className="admin-icon" />
          <FaCog className="admin-icon" />
        </div>
      </nav>

      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-profile">
          <div className="admin-brand">
            <NavLink to="/" className="admin-home-btn">
              <FaHome />
              <span>Admin</span>
            </NavLink>
          </div>
          <img
            src={admin}
            alt="Admin Avatar"
            className="admin-avatar"
          />
          <h3>Khushi</h3>
        </div>

        <nav className="admin-menu">
          <NavLink to="/admin/admindashboard" activeClassName="active">
            <FaColumns />
            Dashboard
          </NavLink>

          <NavLink to="/admin/sliderForm" activeClassName="active">
            <FaSlidersH /> Add Slider
          </NavLink>
          <NavLink to="/admin/sliderForm-Preview" activeClassName="active">
            <FaSlidersH /> Slider Preview
          </NavLink>

          <NavLink to="/admin/contact" activeClassName="active">
            <FaEnvelope /> Contact Us
          </NavLink>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
